import {
  Alert,
  AlertTitle,
  AlertColor,
  LinearProgress as MUILinearProgress,
  LinearProgressProps as MuiLinearProgressProps,
  styled,
  Box,
  Typography,
} from '@mui/material';

// type LinearProgressProps = Omit<MuiLinearProgressProps, 'color'>;

interface LinearProgressProps extends MuiLinearProgressProps {
  barColor?: string;
  theme?: any;
  hideTitle?: boolean;
  isMyProfilePage?: boolean;
}
const LinearProgress = styled(MUILinearProgress)<LinearProgressProps>(
  props => ({
    height: props?.isMyProfilePage ? '13px' : '6px !important',
    backgroundColor: `${
      props.barColor ? `${props.barColor}55` : '#fff'
    } !important`,
    borderRadius: props?.isMyProfilePage ? 0 : 5,
    '.MuiLinearProgress-bar': {
      backgroundColor: `${
        props?.isMyProfilePage
          ? '#4b4b4b'
          : props.barColor ?? props.theme?.palette?.dustGreen?.dark ?? '#000'
      } !important`,
    },
  })
);

function LinearProgressWithLabel(props: LinearProgressProps & {value: number}) {
  return (
    <Box sx={{display: 'flex', alignItems: 'center', height: '16px'}}>
      <Box sx={{width: '100%', mr: 1}}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      {!props.hideTitle && (
        <Box>
          <Typography
            component="span"
            variant={props?.isMyProfilePage ? 'body1' : 'subtitle3'}
            color={
              props?.isMyProfilePage ? '#4b4b4b' : props.barColor ?? 'gray.dark'
            }
            lineHeight={'16px'}
          >{`${Math.round(props.value)}%`}</Typography>
        </Box>
      )}
    </Box>
  );
}

export default LinearProgressWithLabel;
